export const getTokenByType = (token) => localStorage.getItem(token);
